import { TypeArticleWithoutUnresolvableLinksResponse } from 'bb-contentful-types'
type FilterArticleTags = (
  allArticles: TypeArticleWithoutUnresolvableLinksResponse[],
  selectedTags: string[]
) => TypeArticleWithoutUnresolvableLinksResponse[]

export const filterArticleTags: FilterArticleTags = (allArticles, selectedTags) => {
  return allArticles.filter((article) => {
    if (!selectedTags.length) return true
    return article?.fields?.articleTags && article?.fields?.articleTags?.find((tag) => selectedTags.includes(tag))
  })
}
